function data() {
    return {

        productsResult: [],

        formActivated: false,

        init() {
            document.addEventListener("DOMContentLoaded", () => {
                window.addEventListener("showSearchForm", (eve) => {
                    this.formActivated = true;
                });
                this.$watch('formActivated', val => this.showForm(val));
            });
            // Reiniciamos modulo si no es mobile
            window.addEventListener('resize', () => {
                if (!this.isMobile()) location.reload()
            })
        },

        fetchProducts(val) {
            if(val == '') {
                return;
            }
            fetch(window.Shopify.routes.root + "search/suggest.json?q=" + val + "&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title")
                .then((response) => response.json())
                .then((suggestions) => {
                    const productSuggestions = suggestions.resources.results.products;
                    if (productSuggestions.length > 0) {
                        let itemsMaped = productSuggestions.map(item => {
                            item['price_in_clp'] = new Intl.NumberFormat('es-CL', {style: 'currency', currency: 'CLP'}).format(item.price);
                              return item;
                        });
                        this.productsResult = itemsMaped;
                        return
                    }
                    this.productsResult = [];
                }
                );
        },

        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },

        closeGrid() {
            this.$refs.search.value = "";
            this.formActivated = false;
            this.productsResult = [];
        },

        showForm(val) {
            this.calculateHeightWrapSearch();
            this.headerBackgroundToggle(val);
        },

        calculateHeightWrapSearch() {
            const headerSelector = "._header-24";
            const wrapSelector = "._wrap-results";
            const header = document.querySelector(headerSelector);
            const wrapResults = document.querySelector(wrapSelector);

            function screenHeight() {
                var alto = window.innerHeight;
                // Verificar si hay barras de navegación
                if (window.visualViewport && window.visualViewport.height < window.innerHeight) {
                    // Ajustar el alto para compensar las barras de navegación
                    alto = window.visualViewport.height;
                }
                return alto;
            }

            if (header && wrapResults) {
                headerHeight = header.getBoundingClientRect().height;
                wrapHeightCalculated = screenHeight() - headerHeight;
                wrapResults.style.height = `${wrapHeightCalculated}px`;
            }
        },

        headerBackgroundToggle(val) {
            if (screen.width >= 830) {
                const header = document.querySelector("._header-24");
                if (!val) {
                    document.documentElement.style.overflow = '';
                    header.style.background = "rgb(49 38 29 / 30%)";
                    return;
                }
                document.documentElement.style.overflow = "hidden";
                header.style.background = "rgb(49 38 29 / 100%)";
            }
        }
    }
}